

export const generateQuestions = (numQuestions, type, level) => {
    const questions = [];
    for (let i = 0; i < numQuestions; i++) {
        const question = generateQuestion(type, level);
        questions.push(question);
    }
    return questions;
}

const generateQuestion = (type, level) => {
    const question = {};
    question.type = type;
    question.level = level;
    question.question = generateQuestionText(type, level);
    question.answer = generateAnswer(question.question);
    question.options = generateOptions(question.answer);
    return question;
}

const generateQuestionText = (type, level) => {
    switch (type) {
        case 'addition':
            return generateAdditionQuestion(level);
        case 'subtraction':
            return generateSubtractionQuestion(level);
        case 'multiplication':
            return generateMultiplicationQuestion(level);
        case 'division':
            return generateDivisionQuestion(level);
        default:
            return generateAdditionQuestion(level);
    }
}

const generateAdditionQuestion = (level) => {
    const num1 = generateNumber(level);
    const num2 = generateNumber(level);
    return `${num1} + ${num2}`;
}

const generateSubtractionQuestion = (level) => {
    const num1 = generateNumber(level);
    const num2 = generateNumber(level);
    return `${num1} - ${num2}`;
}

const generateMultiplicationQuestion = (level) => {
    const num1 = generateNumber(level);
    const num2 = generateNumber(level);
    return `${num1} x ${num2}`;
}

const generateDivisionQuestion = (level) => {
    const num1 = generateNumber(level);
    const num2 = generateNumber(level);
    return `${num1} / ${num2}`;
}

const generateNumber = (level) => {
    switch (level) {
        case 'veryeasy':
            return generateNumberVeryEasy();
        case 'easy':
            return generateNumberEasy();
        case 'medium':
            return generateNumberMedium();
        case 'hard':
            return generateNumberHard();
        default:
            return generateNumberEasy();
    }
}

const generateNumberVeryEasy = () => {
    return Math.floor(Math.random() * 5);
}

const generateNumberEasy = () => {
    return Math.floor(Math.random() * 10);
}

const generateNumberMedium = () => {
    return Math.floor(Math.random() * 100);
}

const generateNumberHard = () => {
    return Math.floor(Math.random() * 1000);
}

const generateAnswer = (question) => {
    const [num1, operator, num2] = question.split(' ');
    switch (operator) {
        case '+':
            return parseInt(num1) + parseInt(num2);
        case '-':
            return parseInt(num1) - parseInt(num2);
        case 'x':
            return parseInt(num1) * parseInt(num2);
        case '/':
            return parseInt(num1) / parseInt(num2);
        default:
            return parseInt(num1) + parseInt(num2);
    }
}

const generateOptions = (answer) => {
    const options = [];
    options.push(answer);
    while (options.length < 4) {
        const option = generateOption(answer);
        if (!options.includes(option)) {
            options.push(option);
        }
    }
    return shuffle(options);
}

const generateOption = (answer) => {
    const option = answer + Math.floor(Math.random() * 10) - 5;
    return option;
}

const shuffle = (array) => {
    let currentIndex = array.length;
    let randomIndex;
    while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
}
/*
const questions = generateQuestions(5, 'multiplication', 'easy');
      console.log(questions);
const veryeasyquestions = generateQuestions(10, 'addition', 'easy');
        console.log(veryeasyquestions);
const mediumquestions = generateQuestions(10, 'addition', 'medium');
        console.log(mediumquestions);
*/